import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

/**
 * Слайдер карточек "Другие материалы по теме".
 * Пример расположения: карточка статьи, когда в админке
 * включено св-во 'Отображать "Почитать по теме"'.
 * @constructor
 */
export default function GallerySlider() {
  // eslint-disable-next-line no-new
  new Swiper('.gallery-slider_variable .swiper', {
    direction: 'horizontal',
    rewind: true,
    slidesPerView: 1,
    spaceBetween: 20,
    draggable: true,
    preloadImages: false,
    autoHeight: true,
    freeMode: {
      enabled: false,
      sticky: false,
    },
    navigation: {
      nextEl: '.gallery-slider_variable .slide-next',
      prevEl: '.gallery-slider_variable .slide-prev',
    },
    breakpoints: {
      1350: {
        slidesPerView: 3,
      },
      635: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
        initialSlide: 0,
      },
    },
  });
}
